import { render } from "./getNotified.svg?vue&type=template&id=9b3cadd2"
const script = {}
script.render = render

export default script